import axios from "axios";
import { API_BASE_URL, API_HEADERS } from "../apiConfig";
import { API_ENDPOINTS } from "../apiEndpoints";

/**
 * Fetch Stripe API keys from backend (sandbox).
 * @param {string} [type='sandbox'] - Query param: 'sandbox' or 'live'
 * @returns {Promise<Array<{Name, Value, GroupCode, Type}>>}
 */
export const getStripeApiKeys = async (type = "sandbox") => {
  const url = `${API_BASE_URL}/${API_ENDPOINTS.GET_StripeApiKeys}?type=${encodeURIComponent(type)}`;
  const response = await axios.get(url, {
    headers: {
      Token: API_HEADERS.Token,
      UserName: API_HEADERS.UserName,
    },
  });
  return response.data;
};

/**
 * Get Stripe publishable key for sandbox checkout.
 * Ensures we only return test-mode publishable keys to prevent mode mismatch.
 * @returns {Promise<string|null>}
 */
export const getStripePublishableKey = async () => {
  const keys = await getStripeApiKeys("sandbox");
  if (!Array.isArray(keys)) return null;

  const item = keys.find((k) => k.Name === "PublishableKey_Test");
  const value = item?.Value;
  if (!value || typeof value !== "string") return null;

  const key = value.trim();
  if (!key.startsWith("pk_")) return null;
  if (!key.startsWith("pk_test_")) return null;

  return key;
};

export const configService = {
  getStripeApiKeys,
  getStripePublishableKey,
};
